import vue from "vue";
import vuex from "vuex";

vue.use(vuex);
export default new vuex.Store({
  state: {
    usuario: "",
    clave: "",
    empId: 0,
    ws: {},
    empName: "",
    rol:'',
    apiKeyYT: null
  },

  getters: {
    usuario: state => {
      return state.usuario;
    },
    empName: state => {
      return state.empName;
    },
    clave: state => {
      return state.clave;
    },
    empId: state => {
      return state.empId;
    },
    ws: state => {
      return state.ws;
    },
    rol: state =>{
      return state.rol;
    },
    apiKeyYT: state =>{
      return state.apiKeyYT;
    }
  },
  mutations: {
    setUser(state, valor) {
      state.usuario = valor;
    },
    setClave(state, valor) {
      state.clave = valor;
    },
    setEmpName(state, valor) {
      state.empName = valor;
    },
    setEmpId(state, valor) {
      state.empId = valor;
    },
    setWs(state, valor) {
      state.ws = valor;
    },
    setRol(state, valor){
      state.rol = valor;
    },
    setApiKeyYT(state, valor){
      state.apiKeyYT = valor;
    },
  }
});
